import { render, staticRenderFns } from "./review-author.vue?vue&type=template&id=31b2e923"
import script from "./review-author.vue?vue&type=script&lang=ts"
export * from "./review-author.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports